// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__15qXH","balanceDisclaimer":"posDashboard_balanceDisclaimer__2XmUi"};